import React from 'react';
import { Menu } from 'antd';
import { DashboardOutlined, EnvironmentOutlined, UserOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../context/AuthContext';

const SidebarMenu = () => {
  const { principal } = React.useContext(AuthContext);

  const items = [
    {
      key: 'main',
      icon: <DashboardOutlined />,
      label: <Link to="/main">Painel</Link>,
    },
    {
      key: 'map-v2',
      icon: <EnvironmentOutlined />,
      label: <Link to="/map-v2">Mapa 2026 (LOS)</Link>,
    },
    ...(principal?.isAdmin
      ? [
          {
            type: 'group',
            label: 'Admin',
            children: [
              {
                key: 'admin-users',
                icon: <UserOutlined />,
                label: <Link to="/admin/users">Usuários</Link>,
              },
            ],
          },
        ]
      : []),
  ];

  return <Menu theme="dark" mode="inline" className="sidebar-menu" items={items} />;
};

export default SidebarMenu;
